<mat-form-field style="width: 100%;" [formGroup]="group">
  <textarea matInput [formControlName]="field.name" [placeholder]="field.label" [rows]="field?.additionalOptions?.rows || 4"></textarea>
  <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
  </ng-container>
</mat-form-field>
